"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkoutMutations = exports.checkoutMutationKeys = void 0;
const checkout_api_1 = require("./checkout.api");
exports.checkoutMutationKeys = {
    all: () => ['checkout'],
    postDeliveryCountry: () => [...exports.checkoutMutationKeys.all(), 'postDeliveryCountry'],
    postDeliveryOption: () => [...exports.checkoutMutationKeys.all(), 'postDeliveryOption'],
    postDelivery: () => [...exports.checkoutMutationKeys.all(), 'postDelivery'],
    postPickupPoint: () => [...exports.checkoutMutationKeys.all(), 'postPickupPoint'],
    postPaymentOptionId: () => [...exports.checkoutMutationKeys.all(), 'postPaymentOptionId'],
    postClickAndCollectStoreId: () => [...exports.checkoutMutationKeys.all(), 'postClickAndCollectStoreId'],
    postSaferpayAlt: () => [...exports.checkoutMutationKeys.all(), 'postSaferpayAlt'],
    postSaferpayToken: () => [...exports.checkoutMutationKeys.all(), 'postSaferpayToken'],
    postOrderPaidByVoucher: () => [...exports.checkoutMutationKeys.all(), 'postOrderPaidByVoucher'],
    postPayment: () => [...exports.checkoutMutationKeys.all(), 'postPayment'],
    postPaymentProviderInput: () => [...exports.checkoutMutationKeys.all(), 'postPaymentProviderInput'],
    postSubmitOrder: () => [...exports.checkoutMutationKeys.all(), 'postSubmitOrder'],
    postSaferpayAlias: () => [...exports.checkoutMutationKeys.all(), 'postSaferpayAlias'],
    postSubmitVoucher: () => [...exports.checkoutMutationKeys.all(), 'postSubmitVoucher'],
};
const checkoutMutations = (apiOptions) => ({
    postDeliveryCountry: {
        mutationKey: exports.checkoutMutationKeys.postDeliveryCountry(),
        mutationFn: (countryId) => (0, checkout_api_1.postDeliveryCountry)(apiOptions, countryId),
    },
    postDeliveryOption: {
        mutationKey: exports.checkoutMutationKeys.postDeliveryOption(),
        mutationFn: (deliveryOptionId) => (0, checkout_api_1.postDeliveryOption)(apiOptions, deliveryOptionId),
    },
    postDelivery: {
        mutationKey: exports.checkoutMutationKeys.postDelivery(),
        mutationFn: (deliveryInfo) => (0, checkout_api_1.postDelivery)(apiOptions, deliveryInfo),
    },
    postPickupPoint: {
        mutationKey: exports.checkoutMutationKeys.postPickupPoint(),
        mutationFn: (params) => (0, checkout_api_1.postPickupPoint)(apiOptions, params),
    },
    postPaymentOptionId: {
        mutationKey: exports.checkoutMutationKeys.postPaymentOptionId(),
        mutationFn: (optionId) => (0, checkout_api_1.postPaymentOptionId)(apiOptions, optionId),
    },
    postClickAndCollectStoreId: {
        mutationKey: exports.checkoutMutationKeys.postClickAndCollectStoreId(),
        mutationFn: (storeId) => (0, checkout_api_1.postClickAndCollectStoreId)(apiOptions, storeId),
    },
    postSaferpayAlt: {
        mutationKey: exports.checkoutMutationKeys.postSaferpayAlt(),
        mutationFn: () => (0, checkout_api_1.postSaferpayAlt)(apiOptions),
    },
    postSaferpayToken: {
        mutationKey: exports.checkoutMutationKeys.postSaferpayToken(),
        mutationFn: (params) => (0, checkout_api_1.postSaferpayToken)(apiOptions, params),
    },
    postOrderPaidByVoucher: {
        mutationKey: exports.checkoutMutationKeys.postOrderPaidByVoucher(),
        mutationFn: () => (0, checkout_api_1.postOrderPaidByVoucher)(apiOptions),
    },
    postPayment: {
        mutationKey: exports.checkoutMutationKeys.postPayment(),
        mutationFn: (paymentData) => (0, checkout_api_1.postPayment)(apiOptions, paymentData),
    },
    postPaymentProviderInput: {
        mutationKey: exports.checkoutMutationKeys.postPaymentProviderInput(),
        mutationFn: (provider) => (0, checkout_api_1.postPaymentProviderInput)(apiOptions, provider),
    },
    postSubmitOrder: {
        mutationKey: exports.checkoutMutationKeys.postSubmitOrder(),
        mutationFn: (params) => (0, checkout_api_1.postSubmitOrder)(apiOptions, params),
    },
    postSaferpayAlias: {
        mutationKey: exports.checkoutMutationKeys.postSaferpayAlias(),
        mutationFn: (aliasId) => (0, checkout_api_1.postSaferpayAlias)(apiOptions, aliasId),
    },
    postSubmitVoucher: {
        mutationKey: exports.checkoutMutationKeys.postSubmitVoucher(),
        mutationFn: (voucherData) => (0, checkout_api_1.postSubmitVoucher)(apiOptions, voucherData),
    },
});
exports.checkoutMutations = checkoutMutations;
//# sourceMappingURL=checkout.mutations.js.map